var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Component, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { isDataSourceEmpty } from '@gh/common-external-shared';
import { getRouteInitData } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { WaitingService } from '@gh/core-ui';
import { beforeCurrentDate } from '@gh/core-util';
import { InvoiceType } from '@gh/customer-shared-data';
import { skip$ } from '@gh/rx/operators';
import { each } from 'lodash';
import { CustomerFinancialRecordBusinessService, } from '../../resources';
import * as i0 from "@angular/core";
import * as i1 from "../../resources";
import * as i2 from "@angular/router";
import * as i3 from "@gh/core-ui";
import * as i4 from "@gh/core-mls";
import * as i5 from "../../../common-external-shared/components/ext-page/ext-page.component";
import * as i6 from "@angular/material/sort";
import * as i7 from "@angular/common";
import * as i8 from "../../../common-external-shared/components/ext-load-tracker/ext-load-tracker.component";
import * as i9 from "@angular/flex-layout/flex";
import * as i10 from "../../../common-external-shared/directives/ext-if-query.directive";
import * as i11 from "@angular/flex-layout/extended";
import * as i12 from "@angular/material/table";
import * as i13 from "@angular/material/icon";
import * as i14 from "./customer-financial-record-payments-list/customer-financial-record-payment-list.component";
import * as i15 from "@angular/material/core";
import * as i16 from "@angular/material/card";
import * as i17 from "../../../core-mls/translation/translate.pipe";
import * as i18 from "../../../core-ui/common/pipes/default-currency.pipe";
import * as i19 from "../../../core-type/pipes/type-format.pipe";
import * as i20 from "../../../common-external-shared/table/connect.pipe";
function CustomerFinancialRecordsListComponent_gh_ext_load_tracker_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "gh-ext-load-tracker", 4);
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-cell", 39);
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_3_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 42);
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_3_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 43);
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 39);
    i0.ɵɵtemplate(1, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_3_mat_icon_1_Template, 1, 0, "mat-icon", 40);
    i0.ɵɵtemplate(2, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_3_mat_icon_2_Template, 1, 0, "mat-icon", 41);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var invoiceData_r24 = ctx.$implicit;
    var ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.isRowExpanded(invoiceData_r24));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.isRowExpanded(invoiceData_r24));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 44);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_invoice_no"));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 45);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var invoiceData_r27 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", invoiceData_r27.invoiceNumber, " ");
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 46);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_invoice_date"));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 47);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "typeFormat");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var invoiceData_r28 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, invoiceData_r28.accountingDate, "ShortDate"));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 46);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_due_date"));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 47);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "typeFormat");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var invoiceData_r29 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, invoiceData_r29.dueDate, "ShortDate"));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 48);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_type"));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 49);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var invoiceData_r30 = ctx.$implicit;
    var ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r13.getInvoiceTypeLabelId(invoiceData_r30.type)));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 50);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_description"));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 51);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var invoiceData_r31 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(invoiceData_r31.description);
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 52);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_invoiced_dollar"));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 53);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "typeFormat");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var invoiceData_r32 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, invoiceData_r32.amountWithGst, "Price"));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 52);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_balance_dollar"));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 53);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "typeFormat");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var invoiceData_r33 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, invoiceData_r33.balance, "Price"));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 54);
    i0.ɵɵelementStart(1, "div", 55);
    i0.ɵɵelement(2, "gh-customer-financial-record-payment-list", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var invoiceData_r34 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("paymentDataSource", invoiceData_r34.paymentDataSource);
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_row_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-row");
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_row_28_Template(rf, ctx) { if (rf & 1) {
    var _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-row", 57);
    i0.ɵɵlistener("click", function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_row_28_Template_mat_row_click_0_listener() { i0.ɵɵrestoreView(_r37); var invoice_r35 = ctx.$implicit; var ctx_r36 = i0.ɵɵnextContext(3); return ctx_r36.onRowExpand(invoice_r35); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var invoice_r35 = ctx.$implicit;
    var ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("expanded-row", ctx_r22.isRowExpanded(invoice_r35))("ext-primary-color", ctx_r22.isInvoiceExpired(invoice_r35));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_row_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-row");
} if (rf & 2) {
    var invoice_r38 = ctx.$implicit;
    var ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("invoice-row-collapsed", !ctx_r23.isRowExpanded(invoice_r38))("invoice-row-expanded", ctx_r23.isRowExpanded(invoice_r38));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-table", 13);
    i0.ɵɵelementContainerStart(1, 14);
    i0.ɵɵtemplate(2, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_2_Template, 1, 0, "mat-header-cell", 15);
    i0.ɵɵtemplate(3, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_3_Template, 3, 2, "mat-cell", 16);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(4, 17);
    i0.ɵɵtemplate(5, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_5_Template, 3, 3, "mat-header-cell", 18);
    i0.ɵɵtemplate(6, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_6_Template, 2, 1, "mat-cell", 19);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(7, 20);
    i0.ɵɵtemplate(8, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_8_Template, 3, 3, "mat-header-cell", 21);
    i0.ɵɵtemplate(9, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_9_Template, 3, 4, "mat-cell", 22);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(10, 23);
    i0.ɵɵtemplate(11, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_11_Template, 3, 3, "mat-header-cell", 21);
    i0.ɵɵtemplate(12, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_12_Template, 3, 4, "mat-cell", 22);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(13, 24);
    i0.ɵɵtemplate(14, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_14_Template, 3, 3, "mat-header-cell", 25);
    i0.ɵɵtemplate(15, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_15_Template, 3, 3, "mat-cell", 26);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(16, 27);
    i0.ɵɵtemplate(17, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_17_Template, 3, 3, "mat-header-cell", 28);
    i0.ɵɵtemplate(18, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_18_Template, 2, 1, "mat-cell", 29);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(19, 30);
    i0.ɵɵtemplate(20, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_20_Template, 3, 3, "mat-header-cell", 31);
    i0.ɵɵtemplate(21, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_21_Template, 3, 4, "mat-cell", 32);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(22, 33);
    i0.ɵɵtemplate(23, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_cell_23_Template, 3, 3, "mat-header-cell", 31);
    i0.ɵɵtemplate(24, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_24_Template, 3, 4, "mat-cell", 32);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(25, 34);
    i0.ɵɵtemplate(26, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_cell_26_Template, 3, 1, "mat-cell", 35);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(27, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_header_row_27_Template, 1, 0, "mat-header-row", 36);
    i0.ɵɵtemplate(28, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_row_28_Template, 1, 4, "mat-row", 37);
    i0.ɵɵtemplate(29, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_mat_row_29_Template, 1, 4, "mat-row", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("dataSource", ctx_r2.invoiceListDataSource)("trackBy", ctx_r2.getInvoiceId);
    i0.ɵɵadvance(27);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r2.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r2.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r2.expandedDisplayedColumns);
} }
function CustomerFinancialRecordsListComponent_ng_container_5_div_23_ng_container_1_mat_icon_56_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 70);
} }
function CustomerFinancialRecordsListComponent_ng_container_5_div_23_ng_container_1_mat_icon_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 71);
} }
function CustomerFinancialRecordsListComponent_ng_container_5_div_23_ng_container_1_mat_card_60_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 64);
    i0.ɵɵelementStart(2, "div", 62);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 63);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 61);
    i0.ɵɵelementStart(8, "div", 62);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 63);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "typeFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 61);
    i0.ɵɵelementStart(15, "div", 62);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 63);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "typeFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 75);
    i0.ɵɵelement(22, "div", 63);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var payment_r46 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 6, "lbl_receipt_no"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(payment_r46.reference);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 8, "lbl_date"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(13, 10, payment_r46.paidDate, "ShortDate"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 13, "lbl_paid_dollar"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(20, 15, payment_r46.amount, "Price"));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_div_23_ng_container_1_mat_card_60_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-card", 72);
    i0.ɵɵelementStart(1, "mat-card-content");
    i0.ɵɵtemplate(2, CustomerFinancialRecordsListComponent_ng_container_5_div_23_ng_container_1_mat_card_60_ng_container_2_Template, 23, 18, "ng-container", 58);
    i0.ɵɵelementStart(3, "div", 61);
    i0.ɵɵelement(4, "div", 63);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 73);
    i0.ɵɵelementStart(6, "div", 62);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 74);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "typeFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var invoice_r41 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", invoice_r41.payments);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 3, "lbl_total_dollar"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(11, 5, invoice_r41.paymentsTotal, "Price"));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_div_23_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    var _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-card", 60);
    i0.ɵɵelementStart(2, "mat-card-content");
    i0.ɵɵelementStart(3, "div", 61);
    i0.ɵɵelementStart(4, "div", 62);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 63);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 61);
    i0.ɵɵelementStart(10, "div", 62);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 63);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 61);
    i0.ɵɵelementStart(17, "div", 62);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 63);
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "typeFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 61);
    i0.ɵɵelementStart(24, "div", 62);
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 63);
    i0.ɵɵtext(28);
    i0.ɵɵpipe(29, "typeFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 61);
    i0.ɵɵelementStart(31, "div", 62);
    i0.ɵɵtext(32);
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 63);
    i0.ɵɵtext(35);
    i0.ɵɵpipe(36, "defaultCurrency");
    i0.ɵɵpipe(37, "typeFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "div", 61);
    i0.ɵɵelementStart(39, "div", 62);
    i0.ɵɵtext(40);
    i0.ɵɵpipe(41, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div", 63);
    i0.ɵɵtext(43);
    i0.ɵɵpipe(44, "defaultCurrency");
    i0.ɵɵpipe(45, "typeFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(46, "div", 64);
    i0.ɵɵelementStart(47, "div", 62);
    i0.ɵɵtext(48);
    i0.ɵɵpipe(49, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(50, "div", 63);
    i0.ɵɵtext(51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "div", 64);
    i0.ɵɵelement(53, "div", 63);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(54, "div", 64);
    i0.ɵɵelementStart(55, "div", 65);
    i0.ɵɵtemplate(56, CustomerFinancialRecordsListComponent_ng_container_5_div_23_ng_container_1_mat_icon_56_Template, 1, 0, "mat-icon", 66);
    i0.ɵɵtemplate(57, CustomerFinancialRecordsListComponent_ng_container_5_div_23_ng_container_1_mat_icon_57_Template, 1, 0, "mat-icon", 67);
    i0.ɵɵelementStart(58, "span", 68);
    i0.ɵɵlistener("click", function CustomerFinancialRecordsListComponent_ng_container_5_div_23_ng_container_1_Template_span_click_58_listener() { i0.ɵɵrestoreView(_r49); var invoice_r41 = ctx.$implicit; var ctx_r48 = i0.ɵɵnextContext(3); return ctx_r48.onRowExpand(invoice_r41); });
    i0.ɵɵtext(59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(60, CustomerFinancialRecordsListComponent_ng_container_5_div_23_ng_container_1_mat_card_60_Template, 12, 8, "mat-card", 69);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var invoice_r41 = ctx.$implicit;
    var ctx_r39 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("no-border-supplement-parent-radius", ctx_r39.isRowExpanded(invoice_r41));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 20, "lbl_invoice_no"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(invoice_r41.invoiceNumber);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 22, "lbl_type"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 24, ctx_r39.getInvoiceTypeLabelId(invoice_r41.type)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 26, "lbl_invoice_date"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(22, 28, invoice_r41.accountingDate, "ShortDate"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(26, 31, "lbl_due_date"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(29, 33, invoice_r41.dueDate, "ShortDate"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(33, 36, "lbl_invoiced_dollar"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(36, 38, i0.ɵɵpipeBind2(37, 40, invoice_r41.amountWithGst, "Price")));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(41, 43, "lbl_balance_dollar"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(44, 45, i0.ɵɵpipeBind2(45, 47, invoice_r41.balance, "Price")));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(49, 50, "lbl_description"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(invoice_r41.invoiceNumber);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", !ctx_r39.isRowExpanded(invoice_r41));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.isRowExpanded(invoice_r41));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r39.toggleReceiptsActionName(invoice_r41), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.isRowExpanded(invoice_r41));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_div_23_mat_card_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-card", 76);
    i0.ɵɵelementStart(1, "mat-card-content");
    i0.ɵɵelementStart(2, "div", 61);
    i0.ɵɵelementStart(3, "div", 62);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 77);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "defaultCurrency");
    i0.ɵɵpipe(9, "typeFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 61);
    i0.ɵɵelementStart(11, "div", 62);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 78);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "defaultCurrency");
    i0.ɵɵpipe(17, "typeFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 4, "lbl_paid_total"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 6, i0.ɵɵpipeBind2(9, 8, ctx_r40.financialRecord.paidTotal, "Price")));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 11, "lbl_invoiced_total"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 13, i0.ɵɵpipeBind2(17, 15, ctx_r40.financialRecord.invoicedTotal, "Price")));
} }
function CustomerFinancialRecordsListComponent_ng_container_5_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CustomerFinancialRecordsListComponent_ng_container_5_div_23_ng_container_1_Template, 61, 52, "ng-container", 58);
    i0.ɵɵpipe(2, "connect");
    i0.ɵɵtemplate(3, CustomerFinancialRecordsListComponent_ng_container_5_div_23_mat_card_3_Template, 18, 18, "mat-card", 59);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 2, ctx_r3.invoiceListDataSource));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ghExtIfQuery", "lt-md");
} }
function CustomerFinancialRecordsListComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CustomerFinancialRecordsListComponent_ng_container_5_mat_table_1_Template, 30, 5, "mat-table", 5);
    i0.ɵɵelementStart(2, "div", 6);
    i0.ɵɵelement(3, "div", 7);
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵelementStart(5, "div", 9);
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(9, ":\u00A0");
    i0.ɵɵelementStart(10, "span", 10);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "defaultCurrency");
    i0.ɵɵpipe(13, "typeFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 11);
    i0.ɵɵelementStart(15, "span");
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(18, ":\u00A0");
    i0.ɵɵelementStart(19, "span", 10);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "defaultCurrency");
    i0.ɵɵpipe(22, "typeFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(23, CustomerFinancialRecordsListComponent_ng_container_5_div_23_Template, 4, 4, "div", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ghExtIfQuery", "gt-sm");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 6, "lbl_paid_total"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 8, i0.ɵɵpipeBind2(13, 10, ctx_r1.financialRecord.paidTotal, "Price")));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 13, "lbl_invoiced_total"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 15, i0.ɵɵpipeBind2(22, 17, ctx_r1.financialRecord.invoicedTotal, "Price")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ghExtIfQuery", "lt-md");
} }
var CustomerFinancialRecordsListComponent = /** @class */ (function () {
    function CustomerFinancialRecordsListComponent(businessService, route, waitingService, translationService) {
        this.businessService = businessService;
        this.route = route;
        this.waitingService = waitingService;
        this.translationService = translationService;
        this.displayedColumns = [
            'dropDownAction',
            'invoiceNumber',
            'accountingDate',
            'dueDate',
            'type',
            'description',
            'amountWithGst',
            'balance',
        ];
        this.expandedDisplayedColumns = ['payments']; // paymentDataSource
        this.invoiceListDataSource = new MatTableDataSource([]);
    }
    Object.defineProperty(CustomerFinancialRecordsListComponent.prototype, "isRecordsExist", {
        get: function () {
            return !isDataSourceEmpty(this.invoiceListDataSource);
        },
        enumerable: true,
        configurable: true
    });
    CustomerFinancialRecordsListComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _a = getRouteInitData(this.route), financialRecord = _a.financialRecord, invoiceType = _a.invoiceType;
        this.initFinancialInvoiceList(financialRecord);
        this.invoiceListDataSource.sort = this.sort;
        this.invoiceType = invoiceType;
        this.route.paramMap.pipe(skip$(1))
            .subscribe(function (_a) {
            var params = _a.params;
            _this.jobId = params.jobId;
            _this.loadFinancialInvoices(_this.jobId);
        });
    };
    CustomerFinancialRecordsListComponent.prototype.onRowExpand = function (invoiceData) {
        this.expandedInvoice = !this.isRowExpanded(invoiceData)
            ? invoiceData
            : void 0;
    };
    CustomerFinancialRecordsListComponent.prototype.isInvoiceExpired = function (_a) {
        var dueDate = _a.dueDate;
        return beforeCurrentDate(dueDate);
    };
    CustomerFinancialRecordsListComponent.prototype.getInvoiceId = function (index, invoice) {
        return invoice.invoiceId;
    };
    CustomerFinancialRecordsListComponent.prototype.isRowExpanded = function (invoice) {
        return this.expandedInvoice
            ? this.expandedInvoice.invoiceId === invoice.invoiceId
            : false;
    };
    CustomerFinancialRecordsListComponent.prototype.toggleReceiptsActionName = function (invoice) {
        return this.isRowExpanded(invoice)
            ? this.translationService.get('lbl_hide_receipts')
            : this.translationService.get('lbl_show_receipts');
    };
    CustomerFinancialRecordsListComponent.prototype.getInvoiceTypeLabelId = function (type) {
        switch (type) {
            case InvoiceType.Draw:
                return 'lbl_draw';
            case InvoiceType.ChangeOrder:
                return 'lbl_change_order';
            case InvoiceType.CreditNote:
                return 'lbl_credit_note';
            default:
                return '';
        }
    };
    CustomerFinancialRecordsListComponent.prototype.loadFinancialInvoices = function (jobId) {
        this.businessService
            .get(jobId).pipe(this.waitingService.operator())
            .subscribe(this.initFinancialInvoiceList.bind(this));
    };
    CustomerFinancialRecordsListComponent.prototype.getTableRows = function (invoiceList) {
        var rows = [];
        each(invoiceList, function (invoice) {
            return rows.push(__assign(__assign({}, invoice), { dropDownAction: true, paymentDataSource: new MatTableDataSource(invoice.payments) }));
        });
        return rows;
    };
    CustomerFinancialRecordsListComponent.prototype.initFinancialInvoiceList = function (financialRecord) {
        this.financialRecord = financialRecord;
        this.invoiceListDataSource.data = this.getTableRows(financialRecord.invoices);
        this.invoiceListDataSource.sort = this.sort;
    };
    CustomerFinancialRecordsListComponent.ɵfac = function CustomerFinancialRecordsListComponent_Factory(t) { return new (t || CustomerFinancialRecordsListComponent)(i0.ɵɵdirectiveInject(i1.CustomerFinancialRecordBusinessService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i3.WaitingService), i0.ɵɵdirectiveInject(i4.TranslationService)); };
    CustomerFinancialRecordsListComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomerFinancialRecordsListComponent, selectors: [["gh-customer-financial-records-list"]], viewQuery: function CustomerFinancialRecordsListComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatSort, true);
        } if (rf & 2) {
            var _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
        } }, decls: 6, vars: 5, consts: [[3, "title"], ["matSort", ""], ["fxFlex", "", "noData", "", 4, "ngIf"], [4, "ngIf"], ["fxFlex", "", "noData", ""], ["multiTemplateDataRows", "", 3, "dataSource", "trackBy", 4, "ghExtIfQuery"], ["fxShow", "", "fxHide.lt-md", "true", "fxLayout", "row", 1, "footer"], ["fxLayoutAlign", "start", 1, "footer-container", "first"], ["fxLayout", "row", "fxLayoutAlign", "start", "fxLayoutGap", "30px", 1, "footer-container"], [1, "footer-container-item", "paid-total"], [1, "value"], [1, "footer-container-item", "invoiced-total"], [4, "ghExtIfQuery"], ["multiTemplateDataRows", "", 3, "dataSource", "trackBy"], ["matColumnDef", "dropDownAction"], ["fxFlex", "25px", 4, "matHeaderCellDef"], ["fxFlex", "25px", 4, "matCellDef"], ["matColumnDef", "invoiceNumber"], ["fxFlex", "90px", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "90px", 4, "matCellDef"], ["matColumnDef", "accountingDate"], ["fxFlex", "110px", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "110px", 4, "matCellDef"], ["matColumnDef", "dueDate"], ["matColumnDef", "type"], ["fxFlex", "140px", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "140px", 4, "matCellDef"], ["matColumnDef", "description"], ["fxFlex", "40%", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "40%", 4, "matCellDef"], ["matColumnDef", "amountWithGst"], ["fxFlex", "100px", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "100px", "fxLayoutAlign", "end", 4, "matCellDef"], ["matColumnDef", "balance"], ["matColumnDef", "payments"], ["fxFlex", "100%", 4, "matCellDef"], [4, "matHeaderRowDef"], ["matRipple", "", "class", "invoice-row mat-row-clickable", 3, "expanded-row", "ext-primary-color", "click", 4, "matRowDef", "matRowDefColumns"], [3, "invoice-row-collapsed", "invoice-row-expanded", 4, "matRowDef", "matRowDefColumns"], ["fxFlex", "25px"], ["svgIcon", "gh:arrow_drop_down", "class", "drop-down-arrow rotate-270", 4, "ngIf"], ["svgIcon", "gh:arrow_drop_down", "class", "drop-down-arrow", 4, "ngIf"], ["svgIcon", "gh:arrow_drop_down", 1, "drop-down-arrow", "rotate-270"], ["svgIcon", "gh:arrow_drop_down", 1, "drop-down-arrow"], ["fxFlex", "90px", "mat-sort-header", ""], ["fxFlex", "90px"], ["fxFlex", "110px", "mat-sort-header", ""], ["fxFlex", "110px"], ["fxFlex", "140px", "mat-sort-header", ""], ["fxFlex", "140px"], ["fxFlex", "40%", "mat-sort-header", ""], ["fxFlex", "40%"], ["fxFlex", "100px", "mat-sort-header", ""], ["fxFlex", "100px", "fxLayoutAlign", "end"], ["fxFlex", "100%"], [1, "invoice-details"], [3, "paymentDataSource"], ["matRipple", "", 1, "invoice-row", "mat-row-clickable", 3, "click"], [4, "ngFor", "ngForOf"], ["class", "card-list-footer", 4, "ghExtIfQuery"], [1, "card-list-item", "card-with-supplement"], [1, "card-content-item"], [1, "card-content-item-title"], [1, "card-content-item-value"], [1, "card-content-item", "full-width"], [1, "card-content-item-value", "card-actions"], ["svgIcon", "gh:arrow_drop_down", "class", "rotate-270", 4, "ngIf"], ["svgIcon", "gh:arrow_drop_down", 4, "ngIf"], [1, "card-toggle-action", 3, "click"], ["class", "card-supplement", 4, "ngIf"], ["svgIcon", "gh:arrow_drop_down", 1, "rotate-270"], ["svgIcon", "gh:arrow_drop_down"], [1, "card-supplement"], [1, "card-content-item", "card-supplement-footer"], [1, "card-content-item-value", "value"], [1, "card-content-item", "full-width", "footer-divider"], [1, "card-list-footer"], [1, "card-content-item-value", "paid-total"], [1, "card-content-item-value", "invoiced-total"]], template: function CustomerFinancialRecordsListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "gh-ext-page");
            i0.ɵɵelement(1, "gh-ext-page-title", 0);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementStart(3, "gh-ext-page-content", 1);
            i0.ɵɵtemplate(4, CustomerFinancialRecordsListComponent_gh_ext_load_tracker_4_Template, 1, 0, "gh-ext-load-tracker", 2);
            i0.ɵɵtemplate(5, CustomerFinancialRecordsListComponent_ng_container_5_Template, 24, 20, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 3, "lbl_financial_records"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.isRecordsExist);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isRecordsExist);
        } }, directives: [i5.ExtPageComponent, i5.ExtPageTitleDirective, i5.ExtPageContentComponent, i6.MatSort, i7.NgIf, i8.ExtLoadTrackerComponent, i9.DefaultFlexDirective, i10.ExtIfQueryDirective, i11.DefaultShowHideDirective, i9.DefaultLayoutDirective, i9.DefaultLayoutAlignDirective, i9.DefaultLayoutGapDirective, i12.MatTable, i12.MatColumnDef, i12.MatHeaderCellDef, i12.MatCellDef, i12.MatHeaderRowDef, i12.MatRowDef, i12.MatHeaderCell, i12.MatCell, i13.MatIcon, i6.MatSortHeader, i14.CustomerFinancialRecordPaymentListComponent, i12.MatHeaderRow, i12.MatRow, i15.MatRipple, i7.NgForOf, i16.MatCard, i16.MatCardContent], pipes: [i17.TranslatePipe, i18.DefaultCurrencyPipe, i19.TypeFormatPipe, i20.ConnectPipe], styles: [".mat-row[_ngcontent-%COMP%]:nth-of-type(odd) {\n  background: none; }\n\n.mat-row[_ngcontent-%COMP%]:nth-of-type(4n-1) {\n  background: rgba(234, 234, 234, 0.5); }\n\nmat-row.detail-row[_ngcontent-%COMP%] {\n  height: 0; }\n\nmat-row.invoice-row[_ngcontent-%COMP%] {\n  cursor: pointer; }\n  mat-row.invoice-row[_ngcontent-%COMP%]:not(.expanded-row):hover {\n    background: #f5f5f5; }\n  mat-row.invoice-row[_ngcontent-%COMP%]:not(.expanded-row):active {\n    background: #efefef; }\n  mat-row.invoice-row[_ngcontent-%COMP%]   .expanded-row[_ngcontent-%COMP%] {\n    border-bottom-color: transparent; }\n  mat-row.invoice-row[_ngcontent-%COMP%]   mat-cell[_ngcontent-%COMP%] {\n    border-bottom-width: 0; }\n    mat-row.invoice-row[_ngcontent-%COMP%]   mat-cell[_ngcontent-%COMP%]:first-child   .drop-down-arrow[_ngcontent-%COMP%] {\n      color: rgba(112, 112, 112, 0.54);\n      position: absolute;\n      left: 0;\n      top: 11px; }\n\n.invoice-details[_ngcontent-%COMP%] {\n  width: 70%;\n  padding-bottom: 10px; }\n\ndiv.footer[_ngcontent-%COMP%] {\n  margin: 20px 0; }\n  div.footer[_ngcontent-%COMP%]   div.footer-container.first[_ngcontent-%COMP%] {\n    width: 40%; }\n  div.footer[_ngcontent-%COMP%]   div.footer-container[_ngcontent-%COMP%]   .footer-container-item[_ngcontent-%COMP%]   span.value[_ngcontent-%COMP%] {\n    font-weight: bold; }\n  div.footer[_ngcontent-%COMP%]   div.footer-container[_ngcontent-%COMP%]   .footer-container-item.paid-total[_ngcontent-%COMP%] {\n    color: rgba(112, 112, 112, 0.87); }\n\nmat-card.card-with-supplement[_ngcontent-%COMP%] {\n  margin-bottom: 0; }\n  mat-card.card-with-supplement[_ngcontent-%COMP%]   .card-content-item[_ngcontent-%COMP%]   .card-content-item-value.card-actions[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%] {\n    position: absolute;\n    left: 10px;\n    bottom: 10px; }\n  mat-card.card-with-supplement[_ngcontent-%COMP%]   .card-content-item[_ngcontent-%COMP%]   .card-content-item-value.card-actions[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] {\n    margin-left: 25px; }\n  mat-card.card-with-supplement[_ngcontent-%COMP%]   .card-content-item[_ngcontent-%COMP%]   .card-content-item-value[_ngcontent-%COMP%]   span.card-toggle-action[_ngcontent-%COMP%] {\n    cursor: pointer;\n    color: #b7022f; }\n\nmat-card.card-supplement[_ngcontent-%COMP%] {\n  background-color: rgba(234, 234, 234, 0.5);\n  margin-top: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0; }\n  mat-card.card-supplement[_ngcontent-%COMP%]   .footer-divider[_ngcontent-%COMP%] {\n    border-bottom: 1px solid #d3d3d3; }\n  mat-card.card-supplement[_ngcontent-%COMP%]   .card-supplement-footer[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%] {\n    font-weight: bold; }\n\nmat-card.card-list-footer[_ngcontent-%COMP%] {\n  border: 0; }\n  mat-card.card-list-footer[_ngcontent-%COMP%]   .card-content-item-value[_ngcontent-%COMP%] {\n    font-weight: bold; }\n    mat-card.card-list-footer[_ngcontent-%COMP%]   .card-content-item-value.paid-total[_ngcontent-%COMP%] {\n      color: rgba(112, 112, 112, 0.87); }\n\nmat-card.card-list-item[_ngcontent-%COMP%]    + mat-card.card-supplement[_ngcontent-%COMP%]:hover {\n  border-color: #b7022f; }\n\nmat-card.no-border-supplement-parent-radius[_ngcontent-%COMP%] {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0; }\n\n.rotate-270[_ngcontent-%COMP%] {\n  transform: rotate(270deg); }\n\n.invoice-row-collapsed[_ngcontent-%COMP%] {\n  height: 0;\n  minHeight: 0;\n  display: none !important; }\n\n.invoice-row-expanded[_ngcontent-%COMP%] {\n  height: auto; }"] });
    return CustomerFinancialRecordsListComponent;
}());
export { CustomerFinancialRecordsListComponent };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CustomerFinancialRecordsListComponent, [{
        type: Component,
        args: [{
                selector: 'gh-customer-financial-records-list',
                templateUrl: 'customer-financial-records-list.component.html',
                styleUrls: ['customer-financial-records-list.component.scss'],
            }]
    }], function () { return [{ type: i1.CustomerFinancialRecordBusinessService }, { type: i2.ActivatedRoute }, { type: i3.WaitingService }, { type: i4.TranslationService }]; }, { sort: [{
            type: ViewChild,
            args: [MatSort, { static: false }]
        }] }); })();
